/* Canonical MLAP layer colours. Meaning→purple, Landscape→blue, Architecture→green,
   Pathways→amber, Emerging→orange, Opportunities→clay. Used only for the layer
   marker on a card and in exports — the interface stays monochrome. */
export type LayerName = 'meaning' | 'landscape' | 'architecture' | 'pathways' | 'emerging_issues' | 'transformation_opportunities';
export const LAYER_COLOURS: Record<LayerName, string> = {
  meaning: 'var(--layer-meaning)', landscape: 'var(--layer-landscape)', architecture: 'var(--layer-architecture)',
  pathways: 'var(--layer-pathways)', emerging_issues: 'var(--layer-emerging)', transformation_opportunities: 'var(--layer-opportunities)',
};
export const LAYER_LABELS: Record<LayerName, string> = {
  meaning: 'Meaning', landscape: 'Landscape', architecture: 'Architecture', pathways: 'Pathways', emerging_issues: 'Emerging issues', transformation_opportunities: 'Transformation opportunities',
};
